import { callAPI } from "@utils/Api";

export const getCarImage = (vin) =>
  window.ENV.REACT_APP_DISABLE_IMAGES === "true"
    ? { image_urls: [] }
    : callAPI("vehicle/actual/images", "post", {
        token: window.ENV.REACT_APP_ACTUAL_IMAGES_TOKEN,
        vin,
      });
